// extracted by mini-css-extract-plugin
export default {"Message":"ChatBubble_Message__AZIbM","FromPharmacy":"ChatBubble_FromPharmacy__G8Mti","FromUser":"ChatBubble_FromUser__JSwSe","NoTail":"ChatBubble_NoTail__XMYGP"};